export default __webpack_public_path__ + "images/8067c0e88a8dee3e416838d9ce33c187-light_theme.png";